import { DEFAULT_LOCATIONS, QUANTUM_DEMO, PASSWORD } from 'utils/constants';
import { selectToken, EnvTokenMap } from 'utils/selectToken';
import { IndividualLocalClientConfig } from './localConfig.types';

export const apiTokens: EnvTokenMap = {
  dev: 'Token 677e4cb317291d12da5eb199e1cbc9be832dfc3b',
  staging: 'Token fc336dfa11758f30888bbd0a8185b1a452ea7080',
  prod: 'Token 88c64e7203e014a85b97bc08a4686caacbea5f2d',
};

const token = selectToken(apiTokens);

const quantumDemoConfig: IndividualLocalClientConfig = {
  // config name used for fetching client config from fusion
  CONFIG_NAME: 'quantum-demo',

  API_TOKEN: token,
  EMBOLD_CLIENT: QUANTUM_DEMO,

  // login
  SHOW_REGION_SELECTOR: true,
  PASSWORD_REGEX: ['quantumdemo|demo', 'i'],

  // other
  DEFAULT_LOCATION: { ...DEFAULT_LOCATIONS.Nashville },
  LOGIN_NETWORK_NAME: 'quantumDemoUserId',

  // content
  DISPLAY_NAME: 'Quantum Health Demo',
  FORM_VARIANT: PASSWORD,
  NO_WELCOME_LINK: true,
};

export default quantumDemoConfig;
